@use "../../styles/breakpoint.module.scss" as *;

.root {
    grid-column: col-start 4 / span 9;

    @media ($below-mobile) {
        grid-column: margin;
        border-top: 1px solid var(--mid-gray);
        padding-inline: var(--spacer-margin);
    }
}

.item {
    display: grid;
    grid-template-columns: 2fr 1fr;
    grid-template-areas: "txt img";
    align-items: start;
    column-gap: var(--spacer-gutter);
    cursor: pointer;
    padding-block: var(--spacer-40);
    border-bottom: 1px solid var(--mid-gray);

    &[data-hovered] {
        .title {
            text-decoration: underline;
        }

        .tileImage {
            box-shadow: var(--box-shadow-2);
        }
    }

    @media ($below-mobile) {
        grid-template-columns: 1fr;
        grid-template-areas:
            "img"
            "txt"
            "dsc";
    }

    @media ($above-mobile) {
        &:first-child {
            margin-top: 0;

            &:not(.featured) {
                padding-top: 0;
            }
        }
    }
}

.itemText {
    grid-area: txt;

    @media ($below-mobile) {
        margin-bottom: var(--spacer-16);
    }
}

.eyebrow {
    composes: fontST20 from "../../styles/typography.module.scss";
    font-weight: bold;
    grid-area: eye;
    align-self: flex-end;
}

.title {
    composes: fontHB48 from "../../styles/typography.module.scss";
    margin-block: var(--spacer-16);
    grid-area: tit;

    &:last-child {
        margin-bottom: 0;
    }
}

.sdesc {
    composes: fontP20 from "../../styles/typography.module.scss";
    grid-area: dsc;
    align-self: flex-start;
}

.tileImage {
    grid-area: img;

    @media ($below-mobile) {
        margin-bottom: var(--spacer-gutter);
    }
}

.resultCount {
    composes: fontB20 from "../../styles/typography.module.scss";
    font-weight: bold;
}

.filters {
    grid-column: col-start 1 / span 3;
    display: flex;
    flex-direction: column;
    row-gap: var(--spacer-32);

    @media ($below-mobile) {
        grid-column: content;
        margin-bottom: var(--spacer-40);
    }
}

.desktop {
    @media ($below-mobile) {
        display: none;
    }
}

.filterTop {
    display: flex;
    justify-content: space-between;
    grid-column: content;
}

.mobileTrigger {
    composes: base from "../Clickables/index.module.scss";
    composes: fontB20 from "../../styles/typography.module.scss";

    @media ($above-mobile) {
        display: none;
    }
}

.modalOverlay {
    position: fixed;
    inset: 0;
    background: rgb(0 0 0 / 40%);
    z-index: 100;
}

.modal {
    composes: grid from "../../styles/layout.module.scss";
    grid-auto-rows: max-content;
    width: 100vw;
    max-height: 100vh;
    overflow-y: auto;
    background: var(--white);
    transform: translateY(-100%);
    transition: transform 200ms ease;

    &[data-exiting] {
        transform: translateY(-100%);
    }

    &:not([data-entering], [data-exiting]) {
        transform: translateY(0);
    }
}

.dialog {
    composes: repeater from "../../styles/layout.module.scss";

    & > button {
        grid-column: content;

        &:not(.closeButton) {
            margin-bottom: var(--spacer-16);
        }
    }
}

.modalFilters {
    grid-column: margin;
    display: flex;
    flex-direction: column;
    row-gap: var(--spacer-32);
    padding-inline: var(--spacer-margin);
    padding-block: var(--spacer-40);
}

.closeButton {
    composes: fontB20 from "../../styles/typography.module.scss";
    composes: base from "../Clickables/index.module.scss";
    display: flex;
    justify-content: space-between;
    padding-block: var(--spacer-16);

    & > :first-child {
        color: var(--red);
        display: flex;
        align-items: center;

        svg {
            width: 16px;
            height: 16px;
        }
    }
}

.featured {
    composes: item;
    background: var(--neutral);
    padding: var(--spacer-24);
    margin-block: var(--spacer-40);
    border-bottom: none;

    @media ($below-mobile) {
        grid-template-areas:
            "txt"
            "img";
    }

    a {
        grid-column: span 2;
        margin-top: var(--spacer-32);
    }
}

.featuredTitle {
    composes: fontHB80 from "../../styles/typography.module.scss";
    margin-block: var(--spacer-8) var(--spacer-16);
}
